import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconDownload({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 33"
      fill={fill}
    >
      <path d="M9.33464 26.4637C7.49221 26.4637 5.92049 25.8294 4.61948 24.5607C3.31847 23.2839 2.66797 21.7284 2.66797 19.894C2.66797 18.3183 3.1407 16.9122 4.08615 15.6758C5.03969 14.4395 6.28413 13.6516 7.81948 13.3122C8.28817 11.6799 9.15282 10.3061 10.4134 9.19099C11.674 8.08392 13.1326 7.40917 14.7892 7.16675V16.9486L12.8498 15.0698L11.1528 16.7667L16.0013 21.6152L20.8498 16.7667L19.1528 15.0698L17.2134 16.9486V7.16675C19.2983 7.44958 21.0316 8.38291 22.4134 9.96675C23.7952 11.5506 24.4862 13.4132 24.4862 15.5546C25.8841 15.7162 27.0397 16.3223 27.9528 17.3728C28.874 18.4072 29.3346 19.6193 29.3346 21.0092C29.3346 22.5284 28.8053 23.8173 27.7468 24.8758C26.6882 25.9344 25.3993 26.4637 23.8801 26.4637H9.33464Z" />
    </svg>
  );
}
